import {Type} from 'class-transformer';

import {serializeType} from '@app/shared/classes/common';

import {AbstractItem} from '@app/shared/classes/item';
import {Project} from '@app/shared/classes/project';
import {Contract} from '@app/shared/classes/contract';
import {PartnerAddress, PartnerContact, TradingPartner} from '@app/shared/classes/trading-partner';
import {ItemType} from "@app/shared/enums/item-type.enum";
import {BillingType} from "@app/shared/enums/billing-type.enum";
import {ApprovalStatusType} from "@app/shared/enums/approval-status-type.enum";
import {FundingType} from "@app/shared/enums/funding-type.enum";

export class SalesOrderSummary {

  salesOrderId: number;
  salesOrderNumber: string;
  purpose: string;
  customerName: string;

  requestedDeliveryDate: string;
  shippedDate: string;
  customerPurchaseOrderNumber: string;
  amount: number;
  currentStatus: string;
}

export class SalesOrderItem {
  id: number;

  itemCatalogId: number;
  itemCatalogName: string;

  @Type(serializeType(AbstractItem)) children: AbstractItem[];

  abstractItemId: number;
  subtype: ItemType;
  fundingType: FundingType;
  sequenceNum?: number;
  nameOrNumber: string;
  description: string;
  unitOfMeasureId: number;
  unitOfMeasureDescription: string;
  isTaxable: boolean;
  qtyOrdered: number;
  unitCost?: number;                     // Transient field
  salesPrice: number;
  extendedPrice: number;
  taxAmount: number;

  itemNotes: string;                    // note on item stored in the catalog; readonly for line item add
  lineNotes: string;                    // note about the item to be shown on PO; processed by PR
  internalNotes: string;                // internal note for approval and other internal use, processed by PR, Invoice and Receipt; Return has its own returnReasons
  purchaseTxnDescription?: string;

  commodityCodeId: number;
  commodityCodeDescription: string;

  version: number;

  taskId?: number;
  taskName?: string;
}

export class SalesOrderInfo {
  id: number;
  orderNumber: string;
  customerPurchaseOrderNumber: string;
  customerId: number;
}

export class SalesOrder {
  id: number;
  version: number;
  submittedOn: string;

  customerPurchaseOrderNumber: string;
  purchaseOrderDate: string;

  orderNumber: string;

  submittedForId: number;
  submittedById: number;
  submittedBy: string;

  defaultChargeCode: string;
  pdfTemplate: string;

  requestedDelivery: string;
  requiredDelivery: string;
  orderedOn: string;

  shippingType: string;
  buyerLocation: string;
  currencyType: string;

  purpose: string;
  description: string;
  currentStatusName?: ApprovalStatusType;
  hasSubmissionError?: boolean;

  subTotalAmount: number;
  taxAmount: number;
  taxRate: number;
  shippingAmount: number;
  discountAmount: number;
  totalOrderAmount: number;

  pdfTemplateId: number;

  contractId: number;
  contractNumber: string;           // for display purpose on summary
  @Type(serializeType(Contract)) contract: Contract;

  projectId: number;
  projectName: string;             // for display purpose on summary
  @Type(serializeType(Project)) project: Project;

  customerId: number;
  customerName: string;            // for display purpose on summary
  @Type(serializeType(TradingPartner)) customer: TradingPartner;

  contactId: number;
  @Type(serializeType(PartnerAddress)) customerAddressDetail: PartnerAddress;
  @Type(serializeType(PartnerContact)) contactDetail: PartnerContact;

  shipToId: number;
  @Type(serializeType(PartnerAddress)) shipToAddressDetail: PartnerAddress;

  billToId: number;
  @Type(serializeType(PartnerAddress)) billToAddressDetail: PartnerAddress;

  @Type(serializeType(SalesOrderItem)) orderItems: Array<SalesOrderItem> = [];

  //Transient fields
  contractBillingType: BillingType;
  projectBillingType: BillingType;

  billToSameAsShipTo: boolean;
}